<ion-content *ngIf="isEventTrackRaceRequestingAPI || isEventTrackRaceRequestingAPI===undefined; else refDoneFetchAPI;">
  <p class="tw-p-4">
    Getting the data. Please wait...
  </p>
</ion-content>

<ng-template #refDoneFetchAPI>
  <ion-content class="wager-content" scroll-y="false" *ngIf="events.length !== 0; else refNoEventsTemplate">
    <div
      [class.tw-pt-[6px]]="!playLiveVideo"
      class="
        eventtrack-selection-section
        country-race-purse
        tw-pr-[15px]
        tw-pl-[15px]
      "
    >
      <div *ngIf="!playLiveVideo" class="tw-flex tw-items-center">

        <!-- Event selection -->
        <ion-select
          #eventSelection
          fill="outline"
          label-placement="stacked"
          interface="popover"
          toggleIcon="chevron-down-outline"
          expandedIcon="chevron-up-outline"
          placeholder="Select Horse Races"
          class="horse-races tw-mr-[7px]"
          (ionChange)="selectEvent($event)"
          (click)="clickEventList()"
          [value]="selectedEvent"
          data-cy="wager-events-dropdown"
          [compareWith]="compareWith"
          [selectedText]="
            (selectedEvent?.CountryCode
                ? selectedEvent?.CountryCode === 'US'|| selectedEvent?.CountryCode === 'CA'
                  ? selectedEvent?.ToteResponse?.EventDetail?.EventName
                  : selectedEvent?.CountryCode + '-' + selectedEvent?.ToteResponse?.EventDetail?.EventName
                : selectedEvent?.ToteResponse?.EventDetail?.EventName
            ) + ' ' +
            (
              selectedEvent?.ToteResponse?.EventDetail?.currentRace?.RaceId
                ?
                  '('+(selectedEvent?.ToteResponse?.EventDetail?.TrackType | getTrackType).charAt(0)
                  + ' R'+selectedEvent?.ToteResponse?.EventDetail?.currentRace?.RaceId+')'
                : ''
            )
          "
          [interfaceOptions]="{
            cssClass: 'ion-select-event-track'
          }"
        >
          <ion-select-option
            [attr.selected]="{true: prevSelectedEvent !== undefined ? prevSelectedEvent.eventName === event.eventName : false}"
            [value]="event" *ngFor="let event of (events | sortEvents: sortBy: eventTypeFilter: setListFavorites); trackBy: trackByFn"
          >
            <span data-cy="event-name">
              {{
                event?.CountryCode
                  ? event?.CountryCode === 'US'|| event?.CountryCode === 'CA'
                    ? event?.ToteResponse?.EventDetail?.EventName
                    : event?.CountryCode + '-' + event?.ToteResponse?.EventDetail?.EventName
                  : event?.ToteResponse?.EventDetail?.EventName
              }}
            </span>

            <span data-cy="current-race">
              {{
                event?.ToteResponse?.EventDetail?.currentRace?.RaceId
                ?
                  '('+(event?.ToteResponse?.EventDetail?.TrackType | getTrackType).charAt(0) +
                  ' R'+event?.ToteResponse?.EventDetail?.currentRace?.RaceId+')'
                : ''
              }}
            </span>

            <span data-cy="event-status">
              {{
                event?.ToteResponse?.EventDetail?.currentRace
                  ? (
                      (event?.ToteResponse?.EventDetail?.currentRace)?.RaceStatus
                        | getRaceStatus: (event?.ToteResponse?.EventDetail?.currentRace)?.PostTime: event?.eventName
                        | countdown: false: event?.eventName | async
                    )
                  : (event?.ToteResponse?.EventDetail?.EventStatus | getEventStatus)
              }}
            </span>
          </ion-select-option>
        </ion-select>

        <!-- Video -->
        <div
          class="play-video play-video-img tw-text-[#FFFFFF] tw-text-[38px]" data-cy="wager-video-button">
          <img
            (click)="playVideo()"
            [class.tw-opacity-50]="
              selectedRace?.RaceStatus === 3
            "
            class="play-icon"
            src="assets/icons/play_event_icon.png"
            alt="play icon"
            data-cy="play-video"
          >
        </div>
      </div>
    </div>

    <!-- Race -->
    <feature-ion-race
      [events]="events"
      [selectedEvent]="selectedEvent"
      [selectedModifier]="selectedModifier"
      [triggerAutoUpdateEvents]="triggerAutoUpdateEvents"
      [currentSelectedFromEventStatus]="selectedEvent?.ToteResponse?.EventDetail?.currentRace
        ? (
            (selectedEvent?.ToteResponse?.EventDetail?.currentRace)?.RaceStatus
            | getRaceStatus: (selectedEvent?.ToteResponse?.EventDetail?.currentRace)?.PostTime: selectedEvent?.eventName
            | countdown: false: selectedEvent?.eventName | async
          )
        : (selectedEvent?.ToteResponse?.EventDetail?.EventStatus | getEventStatus)"
      (doCloseVideoFn)="closeVideo($event)"
      (doSetRaceStatusFn)="doSetRaceStatus($event)"
    />
  </ion-content>
</ng-template>

<ng-template #refNoEventsTemplate>
  <ion-content class="wager-content" *ngIf="!isSystemError; else refRefreshButtonTemplate;">
    <p class="tw-m-4">
      No events available. Please comeback soon…
    </p>
  </ion-content>
</ng-template>

<ng-template #refRefreshButtonTemplate>
  <ion-content class="wager-content">
    <div class="tw-flex tw-w-screen tw-h-screen tw-justify-center tw-items-center">
      <div class="tw-grid">
        <p class="tw-p-[10px]">{{SERVER_ERROR_MESSAGE}}</p>
        <ion-button
          (click)="reloadPage()"
          class="login-btn tw-capitalize tw-mr-[5px] reload-app"
        >
          Reload App
        </ion-button>
      </div>
    </div>
  </ion-content>
</ng-template>

